<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height>
      <v-flex lg8>
        <v-layout align-center justify-center>
          <v-card width="500" class="elevation-12">
            <v-card-text>
              <v-container fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Cambio de contraseña
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      v-model="current_passowrd"
                      v-validate="'required'"
                      data-vv-name="current_passowrd"
                      data-vv-as="contraseña actual"
                      :error-messages="errors.collect('current_passowrd')"
                      label="Contraseña actual"
                      color="black"
                      type="password">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      v-model="password"
                      v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                      data-vv-name="password"
                      data-vv-as="nueva contraseña"
                      :error-messages="errors.collect('password')"
                      label="Nueva contraseña"
                      color="black"
                      type="password">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      v-model="confirm_password"
                      v-validate="'required|min:10|field-capital-letter|field-lowercase-letter|field-alphabetic-characters|field-two-numbers|field-special-chars'"
                      data-vv-name="confirm_password"
                      data-vv-as="confirmar contraseña"
                      :error-messages="errors.collect('confirm_password')"
                      label="Confirmar contraseña"
                      color="black"
                      type="password">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12>
                    <v-btn class="k-orange-linear white--text" block large @click="resetPassword" :disabled="loading">Continuar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" src="https://s3.amazonaws.com/colektia/CDN/img/logowide.png"  width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Sidebar from '@/components/login/Sidebar';
import EventBus from '@/event-bus';

export default {
  inject: ['$validator'],
  components: {
    Sidebar,
  },
  data() {
    return {
      current_passowrd: '',
      password: '',
      confirm_password: '',
      loading: false,
    };
  },
  computed: {
    isValid() {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=(.*[a-zA-Z]){6,})(?=(.*\d){2,})(?=(.*[!@#$%^&*().]){2,}).{10,}$/;
      return regex.test(this.password);
    },
  },
  methods: {
    resetPassword() {
      if (!this.isValid) {
        this.errors.add({
          field: 'confirm_password',
          msg: 'Contraseña invalida, verifique que la contraseña cumple con la politicas.',
        });
        return;
      }
      this.loading = true;
      this.axios.post('user/password/reset', {
        current_passowrd: this.current_passowrd,
        password: this.password,
        confirm_password: this.confirm_password,
      }).then(async ({ data }) => {
        this.loading = false;
        if (data.code === 403) {
          EventBus.$emit('modal', data.message);
        } else {
          localStorage.setItem('changePassword', true);
          sessionStorage.setItem('password', true);
          this.$auth.fetch();
          this.$router.push({
            name: 'home',
          });
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err);
        EventBus.$emit('modal', 'Ups, ocurrio algo inesperado');
      });
    },
  },
};
</script>

<style scoped>
  .position-relative {
    position: relative;
  }
  .timer {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
  .text-danger {
    color: rgb(255, 82, 82);
  }
</style>



// WEBPACK FOOTER //
// src/components/login/ChangePassword.vue